// TODO: deprecate
export var CURRENT = '2.0.0';
export var LIQUORICE = '3.0.0-alpha.0';
export var KUZCO = LIQUORICE;
export var NEXT = LIQUORICE;
export var LIQUORICE_DARK = '3.0.0-dark-mode.0';
export var DARK = LIQUORICE_DARK;
export var LOLLIPOP_LIGHT = '4.0.0-light';
export var LOLLIPOP_DARK = '4.0.0-dark';
export var PANCAKE_LIGHT = '5.0.0-light';
export var PANCAKE_DARK = '5.0.0-dark';
export var isLiquorice = function isLiquorice(designVersion) {
  return designVersion === LIQUORICE || designVersion === LIQUORICE_DARK;
};
export var isLollipop = function isLollipop(designVersion) {
  return designVersion === LOLLIPOP_LIGHT || designVersion === LOLLIPOP_DARK;
};
export var isPancake = function isPancake(designVersion) {
  return designVersion === PANCAKE_LIGHT || designVersion === PANCAKE_DARK;
};
export var isDarkMode = function isDarkMode(designVersion) {
  return designVersion === LIQUORICE_DARK || designVersion === LOLLIPOP_DARK || designVersion === PANCAKE_DARK;
};
//# sourceMappingURL=index.js.map